import { X, Crown, Target, Zap, CheckCircle, ExternalLink } from 'lucide-react';

interface ProModalProps {
  onClose: () => void;
}

export function ProModal({ onClose }: ProModalProps) {
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-lg max-w-md w-full p-6 relative">
        <button 
          onClick={onClose}
          className="absolute top-4 right-4 text-gray-400 hover:text-gray-500"
        >
          <X className="h-6 w-6" />
        </button>
        
        <div className="text-center mb-6">
          <div className="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-blue-100 mb-4">
            <Crown className="h-6 w-6 text-blue-600" />
          </div>
          <h3 className="text-lg font-medium text-gray-900 mb-2">
            Upgrade to Pro
          </h3>
          <p className="text-sm text-gray-500">
            Get 50 resume conversions for just $5
          </p>
        </div>

        <div className="space-y-4 mb-6">
          <div className="flex items-start">
            <div className="flex-shrink-0 flex items-center justify-center h-6 w-6 rounded-full bg-blue-100">
              <Target className="h-4 w-4 text-blue-600" />
            </div>
            <p className="ml-3 text-sm text-gray-500">
              Apply to 50 different jobs with tailored resumes
            </p>
          </div>
          <div className="flex items-start">
            <div className="flex-shrink-0 flex items-center justify-center h-6 w-6 rounded-full bg-blue-100">
              <Zap className="h-4 w-4 text-blue-600" />
            </div>
            <p className="ml-3 text-sm text-gray-500">
              Increase your chances of getting interviews
            </p>
          </div>
          <div className="flex items-start">
            <div className="flex-shrink-0 flex items-center justify-center h-6 w-6 rounded-full bg-blue-100">
              <CheckCircle className="h-4 w-4 text-blue-600" />
            </div>
            <p className="ml-3 text-sm text-gray-500">
              Stand out from other candidates with personalized resumes
            </p>
          </div>
        </div>

        <div className="bg-gray-50 -mx-6 -mb-6 p-6 rounded-b-lg">
          <a
            href="https://t.me/alish_abd"
            target="_blank"
            rel="noopener noreferrer"
            className="w-full inline-flex justify-center items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
          >
            Contact Developer to Upgrade
            <ExternalLink className="ml-2 h-4 w-4" />
          </a>
          <p className="mt-2 text-xs text-center text-gray-500">
            Message on Telegram to get your Pro account activated
          </p>
        </div>
      </div>
    </div>
  );
}